import React,{useContext} from "react";
import { CUSTOM_STYLES, CXR_SUBTABS_ID, CXR_TABS, CXR_TABS_ALLOWED_ROLES, SAVED_SUBTABS_ID, SAVED_TABS, SAVED_TABS_ALLOWED_ROLES } from "../../../../constants/Constants";
import studylistContext from "../../../../context/studylist/StudylistContext";
import { Pivot, PivotItem } from '@fluentui/react';
import { t } from "i18next";
import themeContext from "../../../../context/theme/ThemeContext";
import CustomToolTipHost from "../../../../components/CustomToolTipHost/CustomToolTipHost";
import { HeightTool } from "@cornerstonejs/tools";
import { getEnv } from '../../../../helpers/EnvHelper';

const SavedTabs = () => {

    const {
        roles,
        selectedValue,
        handleSavedTabChange,

      } = useContext(studylistContext);
    const { getThemeColor } = useContext(themeContext);

    let isBvpPlatform = (getEnv("REACT_APP_BVP_PLATFORM") == "true" || getEnv("REACT_APP_BVP_PLATFORM") == true) ? true : false;

    const toolTipProps = {
      calloutProps: {
        styles: {
          beak: { background: getThemeColor("tooltip"),border:getThemeColor("tooltip-border"),borderTop:`1px solid ${getThemeColor("hide-tooltip-border")}`,borderLeft:`1px solid ${getThemeColor("hide-tooltip-border")}`,zIndex:"100",borderRadius:'1px',boxShadow:"none"},
          beakCurtain: { background: getThemeColor("tooltip"),border:getThemeColor("tooltip-border") },
          calloutMain: { background: getThemeColor("tooltip") },
          borderRadius: "5px",
        },
      },
    };
    const loadSelectedXrayTab = (item)=>{
        if(item.props.itemKey === 'saved'){
         handleSavedTabChange(item.props.itemKey, SAVED_TABS.saved, "study_2")
       }else if(item.props.itemKey === 'reviewPending'){
         handleSavedTabChange(item.props.itemKey, SAVED_TABS.reviewPending, "study_21")
       }
     }

    return (
        <>
        { (isBvpPlatform && SAVED_SUBTABS_ID.includes(selectedValue) && SAVED_TABS_ALLOWED_ROLES.includes(roles[0])) && (
             <>
               <div style={{position : "relative", 
               borderLeft: getThemeColor("border"), 
               borderTop: getThemeColor("border")
               }} className="xray-tabs-pivot-top">
                <div className="study-list-hide-cxr-border-top"></div>
                <Pivot  className="xray-tabs-pivot"
                aria-label="Xray tabs"
                linkSize="small"
                linkFormat={'tabs'}
                //selectedKey={selectedValue}
                onLinkClick={(item) => loadSelectedXrayTab(item)}
                >
             
                  <PivotItem headerText={t("study-list.tabs.all-studies")} itemKey="saved"></PivotItem>
                  <PivotItem headerText={t("study-list.tabs.review-pending")} itemKey="reviewPending"> </PivotItem>
                </Pivot>
              </div>
             </>
            )}
        </>
    )
}

export default SavedTabs;